import $ from "jquery";
import angular from "angular";
import chatModule from '../chatModule';

function cookieService($log) {
    "ngInject";

    return {
        isCookieDefined: function (key) {
            return angular.isDefined($.cookie(key)) && $.cookie(key);
        },

        updateCookie: function (key, value, cookieOption) {
            $.cookie(key, JSON.stringify(value), cookieOption);
        },

        retrieveCookie: function (key) {
            return this.isCookieDefined(key) ? JSON.parse($.cookie(key)) : [];
        },

        destroyCookie: function (key, cookieOption) {
            $.cookie(key, null, cookieOption);
        }

    }
};

chatModule.factory("cookieService", cookieService);

export default cookieService;